import React from 'react'

import { RootChartConfigObject } from '../../../types/shared'
import { NotificationWrapper } from '../../components'
import { ElementStyleDialogWrapper } from '../../modals/element_style'
import { useChartLayoutGlobalModelAsync } from '../../utils/useChartLayoutGlobalModelAsync'
import { withSuspense } from '../../website-shared'
import { ChartLayoutComponent } from './chart_layout_component'

interface ChartLayoutProps {
  config: RootChartConfigObject
  shouldResize?: boolean
  parentElement?: HTMLElement
  isWithNotifications?: boolean
}

export function ChartLayout({ config, shouldResize, isWithNotifications = true }: ChartLayoutProps) {
  const Wrapper = isWithNotifications ? NotificationWrapper : React.Fragment
  return (
    <Wrapper>
      <ElementStyleDialogWrapper>
        <ChartLayoutComponent config={config} shouldResize={shouldResize} />
      </ElementStyleDialogWrapper>
    </Wrapper>
  )
}

export function ChartLayoutWithGlobalStateRaw({
  config,
  shouldResize,
  parentElement,
}: Omit<ChartLayoutProps, 'isWithNotifications'>) {
  const { setChartLayoutModel, getChartLayoutModelConfig, lastGlobalRerender } = useChartLayoutGlobalModelAsync()

  return (
    <ElementStyleDialogWrapper>
      {config && (
        <ChartLayoutComponent
          key={lastGlobalRerender}
          config={getChartLayoutModelConfig({ fallback: config })}
          shouldResize={shouldResize}
          onRegisterChartLayoutModel={setChartLayoutModel}
          parentElement={parentElement}
        />
      )}
    </ElementStyleDialogWrapper>
  )
}

export const ChartLayoutWithGlobalState = withSuspense(ChartLayoutWithGlobalStateRaw)
